<template>
    <div>
        <Card shadow>
            <Row :gutter="18">
                <Col span="7" style="display:none">
                    <label style="display: flex; align-items: center">
                        <span style="width: 80px">代理组:</span>
                        <Select v-model="table.params.platids" filterable placeholder="筛选所属分组" clearable multiple :max-tag-count="2" @on-change="updateSelect">
                            <Option v-for="(item, index) in plat_list" :value="item.id" :label="item.name" :key="index">
                                {{ item.name }}
                                <span style="color: #bbb">({{ item.id }})</span>
                            </Option>
                        </Select>
                    </label>
                </Col>
                <Col span="6">
                    <label style="display: flex; align-items: center">
                        <span style="width: 50px">代理:</span>
                        <Select v-model="table.params.app_ids" placeholder="筛选代理">
                            <Option v-for="(item, index) in app_list" v-show="table.params.platids.length == 0 || table.params.platids.includes(item.platform)" :value="item.appid" :label="item.appName" :key="index">
                                {{ item.appName }}
                                <span style="color: #bbb">({{ item.appid }})</span>
                            </Option>
                        </Select>
                    </label>
                </Col>
                <Col span="5">
                    <label style="display: flex; align-items: center">
                        <span style="width: 120px">统计时间:</span>
                        <DatePicker type="daterange" v-model="select.dataTime" placeholder="统计时间" :options="dateOptions"></DatePicker>
                    </label>
                </Col>
                <Col span="7" style="display: flex; justify-content: space-between">
                    <Button type="primary" @click.native="TransTopReq()" :loading="loading" style="margin-right: 10px">
                        <span v-if="!loading">查询</span>
                        <span v-else>loading..</span>
                    </Button>
                    <div>
                        <Button type="primary" style="margin-right: 10px" @click.native="thisToExcel()"> 导出Excel </Button>
                        <Button type="primary" @click.native="toPdf()"> 导出PDF </Button>
                    </div>
                </Col>
            </Row>
        </Card>
        <Table border :columns="table.columns" :data="table.data" :max-height="maxHeight" style="margin-top: 12px" @on-sort-change="sortChange"></Table>
        <Table border ref="tableRef" :columns="table.columns1" :data="table.data1" style="display: none"></Table>
    </div>
</template>
<script>
import { TransTopReq } from '@/api/admin/risk'
import moment from 'moment'
export default {
    name: 'rechargeData',
    data() {
        return {
            tableSetting: {},
            maxHeight: 720,
            loading: false,
            copyDataList: [],
            copyColumn: [],
            TransTopReqTimer: null,
            select: {
                dataTime: [this.getCurrentZeroDay(), this.getCurrentZeroDay()]
            },
            sortName: 'app_name',
            //columns配置参数
            columnConfig: {
                all_pay: { name: '总订单数', tip: '筛选时间内,盘口通道总订单数' },
                all_money: { name: '总订单金额', tip: '筛选时间内,盘口通道总订单金额' },
                pay_ok: { name: '成功订单数', tip: '筛选时间内,盘口通道成功订单数' },
                money_ok: { name: '成功转入金额', tip: '筛选时间内,盘口通道成功转入金额' },
                all_man: { name: '提交订单人数', tip: '筛选时间内,盘口通道提交订单人数' },
                ok_man: { name: '完成订单人数', tip: '筛选时间内,盘口通道完成订单人数' },
                order_rate: { name: '订单转入成功率', tip: '筛选时间内,盘口通道订单转入成功率' },
                money_rate: { name: '成功转入金额占比', tip: '筛选时间内,盘口通道成功转入金额占比' },
                user_rate: { name: '实际完成订单人数比', tip: '筛选时间内,盘口通道实际完成订单人数比' }
            },
            currentSortParam: {},
            table: {
                params: {
                    mod: 'root',
                    platid: 0,
                    platids: [],
                    app_id: 0,
                    app_name: '',
                    platform: 0,
                    app_ids: [],
                    param: {
                        _mod: 'manager',
                        _func: 'GetPayChannelInfo',
                        _param: {
                            platid: 0,
                            app_id: 0,
                            stime: 0,
                            etime: 0,
                            limit: 100000,
                            general: -1,
                            pack_no: -1,
                            page: 1
                        }
                    }
                },
                data: [],
                children: [],
                columns: [],
                columns1: [],
                data1: [],
                total: 0,
                pageSizes: [10, 20, 30, 40]
            }
        }
    },
    methods: {
        //关闭定时器
        closeTimer() {
            this.loading = false
            clearTimeout(this.TransTopReqTimer)
            this.TransTopReqTimer = null
        },
        //批量请求开启定时器8秒超时
        openTimer() {
            this.closeTimer()
            this.loading = true
            this.TransTopReqTimer = setTimeout(() => {
                this.loading = false
            }, 6000)
        },
        thisToExcel() {
            let table = { columns: this.table.columns1, data: this.table.data1 }
            this.eleToExcel(table)
        },
        async toPdf() {
            this.maxHeight = null
            await this.eleToPdf()
            this.maxHeight = 720
        },
        async TransTopReq() {
            if (this.loading) return
            let [stime, etime] = this.select.dataTime
            let sSec = this.getSecond(stime)
            let eSec = this.getSecond(etime, false)
            this.openTimer()
            let allList = this.getAllHttpAppid(this.table.params)
            this.table.data = []
            let httpList = []
            let loadingArr = []
            let date = `${moment(stime).format('YYYY-MM-DD')} - ${moment(etime).format('YYYY-MM-DD')}`
            for (let i = 0, len = allList.length; i < len; i++) {
                let app_id = allList[i]
                let app_name = ''
                let platid = 0
                let item = this.app_list.find((el) => el.appid == app_id)
                if (item) {
                    app_name = item.appName
                    platid = item.platform
                }
                this.table.params.platid = platid
                this.table.params.app_id = app_id
                this.table.params.app_name = app_name
                this.table.params.param._param.app_id = app_id
                this.table.params.param._param.platid = platid
                let start = sSec
                for (; start < eSec; ) {
                    this.table.params.param._param.stime = start
                    this.table.params.param._param.etime = start + 24 * 60 * 60 - 1
                    let param = this.copyData(this.table.params)
                    param.date = date
                    param.time = moment(start * 1000).format('YYYY-MM-DD')
                    start += 26 * 60 * 60
                    httpList.push(param)
                    loadingArr.push(1)
                }
            }
            for (let s = 0; s < 5; s++) {
                this.toHttp(httpList, loadingArr, {})
            }
        },
        async toHttp(httpList, loadingArr) {
            if (httpList.length > 0) {
                let param = httpList[0]
                httpList.shift()
                TransTopReq(param)
                    .then((res) => {
                        if (res._param) {
                            let item = res._param.data
                            item.forEach((el) => {
                                el.app_name = param.app_name
                                el.app_id = param.app_id
                                el.date = param.date
                                el.time = param.time
                                if (el.all_man) {
                                    el.user_rate = el.ok_man / el.all_man
                                } else {
                                    el.user_rate = 0
                                }
                                if (el.all_pay) {
                                    el.order_rate = el.pay_ok / el.all_pay
                                } else {
                                    el.order_rate = 0
                                }
                                if (el.all_money) {
                                    el.money_rate = el.money_ok / el.all_money
                                } else {
                                    el.money_rate = 0
                                }
                                this.table.data1.push(el)
                                let findIndex = this.table.data.findIndex((element) => element.channel_pay_type == el.channel_pay_type)
                                if (findIndex != -1) {
                                    find.all_man += el.all_man
                                    find.ok_man += el.ok_man
                                    find.all_pay += el.all_pay
                                    find.all_money += el.all_money
                                    find.pay_ok += el.pay_ok
                                    find.money_ok += el.money_ok
                                    if (find.all_man) {
                                        find.user_rate = find.ok_man / find.all_man
                                    }
                                    if (find.all_pay) {
                                        find.order_rate = find.pay_ok / find.all_pay
                                    }
                                    if (find.all_money) {
                                        find.money_rate = find.money_ok / find.all_money
                                    }
                                } else {
                                    this.table.data.push(el)
                                }
                            })
                            this.table.data.sort((a, b) => {
                                return a.app_name > b.app_name ? 1 : -1
                            })
                            this.table.data1.sort((a, b) => {
                                if (a.app_name == b.app_name) {
                                    return a.time > b.time ? 1 : -1
                                }
                                return a.app_name > b.app_name ? 1 : -1
                            })
                            this.requestCallBack(loadingArr)
                            this.toHttp(httpList, loadingArr)
                        }
                    })
                    .catch((err) => {
                        this.requestCallBack(loadingArr)
                        this.toHttp(httpList, loadingArr)
                    })
            }
        },
        requestCallBack(list) {
            list.shift()
            if (list.length == 0) {
                this.closeTimer()
            }
        },
        //分组变化清空盘口选择项
        updateSelect() {
            this.table.params.app_ids = []
        },

        //table自定义排序方法
        sortChange(params) {
            this.currentSortParam = params
            let order = params.order == 'desc' ? 1 : -1
            let key = params.key
            this.table.data.sort((a, b) => {
                return a[key] > b[key] ? -1 * order : order
            })
        },
        //获取表格cloumn isExpand:是否子数据
        getColumn(isExcel) {
            let arr = []
            for (let key in this.columnConfig) {
                let val = this.columnConfig[key]
                let item
                if (!!val.tip) {
                    item = {
                        key,
                        align: 'center',
                        sortable: 'custom',
                        minWidth: 100,
                        renderHeader: (h) => this.renderHeader(h, val.name, val.tip)
                    }
                } else {
                    item = {
                        key,
                        align: 'center',
                        sortable: 'custom',
                        minWidth: 100,
                        title: val.name
                    }
                }
                if (key.includes('_rate')) {
                    Object.assign(item, {
                        minWidth: 120,
                        render: (h, params) => h('span', (params.row[key] * 100).toFixed(2) + '%')
                    })
                } else if (key.includes('money')) {
                    Object.assign(item, {
                        minWidth: 120,
                        render: (h, params) => h('span', params.row[key].toFixed(2))
                    })
                }
                arr.push(item)
            }
            let initArr = isExcel
                ? [
                      {
                          key: 'pay_method_name',
                          align: 'center',
                          minWidth: 100,
                          sortable: 'custom',
                          renderHeader: (h) => this.renderHeader(h, '转入端口号', '筛选时间内, 对应的通道ID')
                      },
                      {
                          key: 'date',
                          align: 'center',
                          width: 180,
                          renderHeader: (h) => this.renderHeader(h, '日期', '显示统计信息对应的日期')
                      }
                  ]
                : [
                      {
                          key: 'app_name',
                          align: 'center',
                          minWidth: 100,
                          sortable: 'custom',
                          renderHeader: (h) => this.renderHeader(h, '平台名称', '显示统计信息对应的盘口名称')
                      },
                      {
                          key: 'time',
                          align: 'center',
                          width: 180,
                          renderHeader: (h) => this.renderHeader(h, '日期', '显示统计信息对应的日期')
                      },
                      {
                          key: 'pay_method_name',
                          align: 'center',
                          minWidth: 100,
                          sortable: 'custom',
                          renderHeader: (h) => this.renderHeader(h, '转入端口号', '筛选时间内, 对应的通道ID')
                      }
                  ]
            return [...initArr, ...arr]
        },
        //设置行选中样式
        rowClassName(row, index) {
            let data = this.table.data[index]
            if (data._userCheck || data._expanded) return 'user-table-check'
            return ''
        },
        initFunc() {
            this.table.params.platids = [this.getinitPlatId()]
            this.TransTopReq()
        },
        getAppInfo(item) {
            return this.plat_list.find((el) => el.id == item.platid) || {}
        }
    },
    created() {
        this.table.columns = this.getColumn(true)
        this.table.columns1 = this.getColumn(false)
        this.initFunc()
    }
}
</script>
<style lang="less" scoped>
.btn_batch {
    margin-right: 12px;
}
</style>
